export default __webpack_public_path__ + "static/Declaration-Aqad_EGTB_EN-cb418770ecf3b44a43a4907bfdaeb37d.pdf";